import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import PaymentOptionList from '../../../../../library/inputs/payment/PaymentOptionList';
import { PaymentOption } from '../../../../../../models/form/paymentOption';

interface Props {
  id: string;
  value: Array<string>;
  options: Array<PaymentOption> | undefined;
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  multiSelection: boolean | undefined;
  readOnlyMode: boolean;
  culture?: string;
}

const PaymentOptionListField: FC<Props> = ({
  id,
  value,
  options,
  setFieldTouched,
  setFieldValue,
  multiSelection,
  readOnlyMode,
  culture,
}: Props) => {
  if (!options) return null;

  return (
    <PaymentOptionList
      value={value}
      options={options}
      multiSelection={multiSelection}
      onChange={async (val) => {
        await setFieldValue(id, val, true);
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
      culture={culture}
    />
  );
};

export default PaymentOptionListField;
